module.exports = __webpack_public_path__ + "static/media/travel.f5aab620.svg";